import { render } from "./company-summary.vue?vue&type=template&id=3a4bc54f&scoped=true"
const script = {}

import "./company-summary.vue?vue&type=style&index=0&id=3a4bc54f&scoped=true&lang=less"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a4bc54f"]])

export default __exports__